import AcademicRecordList from './AcademicRecordList';

export default AcademicRecordList; 